

import React, { PureComponent } from 'react';
import { createContainer } from '@dbk-legacy/muster/react';
import { LoadingCircle } from '../../../../../../../src/components/common/loading';
import SuccessIcon from '../../../../../../../src/components/common/icons/success-icon';
import Button from '@dbk/ui-buttons';
import { PALETTE } from '../../constants';

class ReportAdhocSuccess extends PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    const { i18n: { messages }} = this.props;

    return(
      <div className='reportAdhocSuccess'>
        <SuccessIcon color={PALETTE.successColor} width={48} height={48} />

        <div className='reportAdhocSuccess__message'>
          <h2 tabIndex={0}>
            {messages['app.reports.orderReport.successHeader']}
          </h2>
          <p tabIndex={0}>
            {messages['app.reports.orderReport.successSubHeader']} 
          </p>
          <p tabIndex={0}>
            {messages['app.reports.orderReport.successSubHeaderInfo']}
          </p>
        </div>

        <div className='reportAdhocSuccess__actionBtn'>
          <Button
                size='large'
                tertiary
                fullWidth={false}
                onClick={() => this.props.changePage('/reports')}>
                  {messages['app.reports.orderReport.backToReport']}
          </Button>

            <Button
              size='large'
              onClick={this.props.goBack}
              fullWidth={false}>
                {messages['app.reports.orderReport.generateAnotherReport']}
            </Button>
        </div>
      </div>
    )
  }
 
 
  }

export default createContainer({
  $renderLoading: () => <LoadingCircle />,
  $queries: {
   
    changePage: { $call: 'ui.history.push' },
    i18n: {
      messages: true,
    },
    rsa: {
      onChangePage: { $call: 'changePage' },
    },
    goBack: { $call: 'ui.history.goBack' },


  },
})(ReportAdhocSuccess);
